export default {
  state: {
    userComponentsSize: 'default',
    userMonitorType: 'samllSreen',
    cacheComponentsPath: [],
    printList: [],
    screeningResultEdit: false,
    loading: {
      status: false,
      msg: '',
    },
    updateSreeningList: false,
    menuSlideStatus: false,
    screenWidth: {
      offsetWidth: 0,
      offsetHeight: 0,
    },
    step: {
      guideDetailsStatus: false,
      slide: false,
      stepType: 'campus',
    },
  },
  mutations: {
    SET_PRINT_LIST: (state: any, payload: any) => {
      state.printList.push(...payload);
    },
    SET_LOADING_STATUS: (state: any, payload: any) => {
      state.loading.status = payload.status;
      state.loading.msg = payload.msg;
    },
    SET_STEP_TYPE: (state: any, payload: any) => {
      state.step.guideDetailsStatus = payload.guideDetailsStatus;
      state.step.slide = payload.slide;
      state.step.stepType = payload.stepType === undefined ? state.step.stepType : payload.stepType;
    },
    // 更新列表数据
    SET_SCREENING_RESULT_EDIT: (state: any, status: boolean) => {
      state.screeningResultEdit = status;
    },
    // 更新屏幕大小
    SET_SCREEN_WIDTH: (state, value) => {
      state.screenWidth.offsetWidth = value.offsetWidth;
      state.screenWidth.offsetHeight = value.offsetHeight;

      state.userMonitorType = value.offsetWidth > 1700 ? 'bigSreen' : 'samllSreen';
    },
    // 更新菜单收起
    SET_MENU_SLIDE: (state: any, status: boolean) => {
      state.menuSlideStatus = status;
    },
    UPDATE_SCREENING_LIST: (state: any, status: boolean) => {
      state.updateSreeningList = status;
    },
    SET_CACHE_COMPONENTS_PATH: (state: any, path: string) => {
      // console.log(state.cacheComponentsPath.findIndex(path));
      // const index = state.cacheComponentsPath.findIndex(path);
      // if (index === -1) {
      //   state.cacheComponentsPath.push(path);
      // }
      let hasPath = false;
      state.cacheComponentsPath.forEach((item, index) => {
        if (item === path) {
          hasPath = true;
        }
      });
      if (!hasPath) {
        state.cacheComponentsPath.push(path);
      }
    },
    DELETE_CACHE_COMPONENTS_PATH: (state: any, path: string) => {
      // state.cacheComponentsPath.push(path);
      // console.log(state.cacheComponentsPath.findIndex(path));
      // const index = state.cacheComponentsPath.findIndex(path);
      // if (index !== -1) {
      //   state.cacheComponentsPath.splice(index, 1);
      // }
      state.cacheComponentsPath.forEach((item, index) => {
        if (item === path) {
          state.cacheComponentsPath.splice(index, 1);
        }
      });
    },
  },
  actions: {
  },
  getters: {
  },
};
